export const sf = {
  bg: '#0A0A0A',
  bgGradientTop: '#0A0A0A',
  bgGradientBottom: '#0F2A44',
  surface: '#121212',
  surfaceElevated: '#161616',
  primaryDeep: '#0F2A44',
  steelBlue: '#1F4E79',
  accent: '#3A8DFF',
  accentMuted: 'rgba(58, 141, 255, 0.22)',
  accentGlow: 'rgba(58, 141, 255, 0.35)',
  border: '#2A2A2A',
  text: '#E5E7EB',
  textMuted: '#9CA3AF',
  textSubtle: '#6B7280',
  radiusSm: '8px',
  radiusMd: '10px',
  radiusLg: '12px',
  fontSans: '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
  fontDisplay: '"Space Grotesk", "Inter", system-ui, sans-serif',
  transitionFast: '120ms ease',
  touchMin: '48px',
} as const;
